import { addNotification, NotificationType } from '@vista-digital/occ-domain'
import { getLogger } from '../../services'
import type { JobType } from './jobsTasks'
import { tasksMap } from './jobsTasks'

const storageKey = 'storage-timer-'

// To fix undefined getLogger
const logger = () => getLogger('JobScheduler')?.value

export interface JobSchedule {
    jobType: JobType
    scheduleInSeconds: number
    hasNotification: boolean
    task: () => void
}

interface ScheduledJobItem extends Omit<JobSchedule, 'task' | 'scheduleInSeconds'> {
    scheduleInMs: number
}

export const scheduleJob = ({ jobType, scheduleInSeconds = 0, hasNotification = false }: Omit<JobSchedule, 'task'>) => {
    const nowInMs = new Date().getTime()
    const scheduleInMs = nowInMs + scheduleInSeconds * 1000
    setJobItem({ jobType, scheduleInMs, hasNotification })
    enqueJob(jobType)
}

// this will show job message if its job is scheduled and if the messaged wasn't shown before
export const showJobNotification = (jobType: JobType, message?: string) => {
    if (!message) return
    const scheduledJob = getScheduledJob(jobType)
    if (!scheduledJob?.hasNotification) return

    // update notification state before showing a notification
    setJobItem({ jobType, hasNotification: false })
    addNotification({
        id: jobType,
        messages: [{ text: message }],
        type: NotificationType.Info,
        autoDismiss: false,
        actionButton: { show: false },
        closeButton: { show: true },
    })
}

export const initScheduledJobsRunner = () => {
    Object.keys(tasksMap).forEach((job: JobType) => enqueJob(job))
}
// Init a checker for scheduled jobs, and run them, or remove expired jobs
const enqueJob = (job: JobType): void => {
    const jobSchedule = getScheduledJob(job) // Fetched continually in case storage timer is cleared externally.
    logger().info(`checking job ${job}`)
    if (!jobSchedule) {
        logger().info(`no schedule for job ${job}`)
        return
    }

    const timer = setInterval(() => {
        // run task on schedule
        if (new Date().getTime() >= jobSchedule.scheduleInMs) {
            logger().info(`jobs with id found ${job}`)
            const task = tasksMap[job]!
            task()
            removeScheduledJob(job)
            clearInterval(timer)
            logger().info(`removing ${job} from schedule`)
        }
    }, 1000)
}

// gets a schedule in MS
const getScheduledJob = (jobType?: JobType) => {
    if (!jobType) return
    const jobItemStr = localStorage.getItem(`${storageKey}${jobType}`)
    const jobItem = (jobItemStr ? JSON.parse(jobItemStr) : null) as ScheduledJobItem
    if (!jobItem) return
    return jobItem
}

// remove a jobs from a queue
const removeScheduledJob = (jobType: JobType) => {
    const key = `${storageKey}${jobType}`
    localStorage.removeItem(key)
}

// add or update job in a storage
const setJobItem = (job: Partial<ScheduledJobItem>) => {
    const scheduledJob = getScheduledJob(job?.jobType)
    localStorage.setItem(`${storageKey}${job.jobType}`, JSON.stringify({ ...scheduledJob, ...job }))
}
